export type ChatAccessErrorCode = "group_required" | "group_check_unavailable";

/**
 * Reads the group-access code from a chat API 403 or 503 error body. Returns
 * `undefined` for any other error. Reads a clone, so the body stays readable.
 */
export default async function chatAccessErrorCode(
  err: unknown
): Promise<ChatAccessErrorCode | undefined> {
  if (
    !(err instanceof Error) ||
    !("response" in err) ||
    !(err.response instanceof Response)
  ) {
    return undefined;
  }
  const { status } = err.response;
  if (status !== 403 && status !== 503) return undefined;

  try {
    const body = await err.response.clone().json();
    const code = body?.detail?.code;
    if (code === "group_required" || code === "group_check_unavailable") {
      return code;
    }
  } catch {
    // Not JSON, so not a group-access error.
  }
  return undefined;
}
